import React from 'react';
import { autoPlay } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';
import Slide from './Slide';
import { Grid } from '@material-ui/core';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const BlockSwipeable = ({ activeStep, handleStepChange, images }) => (
  <AutoPlaySwipeableViews
    axis={'x'}
    index={activeStep}
    onChangeIndex={handleStepChange}
    enableMouseEvents
    springConfig={{
      duration: '0.35s',
      easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
      delay: '0s',
    }}
    interval={6000}
  >
    {images.map((image, index) => {
      return (
        <Grid
          container
          justify="center"
          alignItems="center"
          key={`Slide${index}`}
        >
          <Slide image={image} index={index} />
        </Grid>
      );
    })}
  </AutoPlaySwipeableViews>
);
export default BlockSwipeable;
